export default {
	'couponDialog.full': '滿',
	'couponDialog.available': '可用',
	'couponDialog.SendYou1Ticket': '送您1張',
	'couponDialog.CouponsThatCanBeOrderedImmediately': '優惠券，可立即下單使用'
};
